
import api from './api'
import { useDownload } from '@/helpers/download'

export default {    
    
    count(params = {}) {

        return api.get('/echeanciers', { params })
            .then( response => parseInt(response.headers['x-pagination-count']) )
    },

    get(id) {

        return api.get('/echeanciers/' + id, {})
            .then( json => json.data )
            
    },

    getXlsx(params = {}) {

        return new Promise((resolve, reject) => {

            api.post('/echeanciers/file', null, { params: params })
                .then( response => {
                    if ( response.status === 204 ) {
                        reject('Aucun fichier à télécharger') 
                    }

                    useDownload(response.headers.location)
                        .then(() => resolve() )
                })
                .catch(() => reject())
        }) 
    },     

    list(params = {}) {

        return api.get('/echeanciers', { params })
            .then( json => json.data )
            
    },

    search(params = {}) {

        return api.get('/echeanciers', { params })
            .then( json => json.data )            
    } 
}
